export const CP_PLUS_GOLD_LOGO_URL = 'https://cld.partsimg.com/image/upload/w_20,dpr_3.8,q_auto:eco/v1781942954/carparts/loyalty-program/cp-gold.png'
export const CP_PLUS_GOLD_LOGO_URL_SM = 'https://cld.partsimg.com/image/upload/w_18,dpr_3.8,q_auto:eco/v1781942954/carparts/loyalty-program/cp-gold.png'
